import { render, staticRenderFns } from "./productionStationSummaryWidget.vue?vue&type=template&id=19276ad0&"
import script from "./productionStationSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./productionStationSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports